import { client } from "@/config/client"

export interface Flashcard {
  id: string
  question: string
  answer: string
}

export interface GetFlashcardResponse {
  id: string
  name: string
  index: number
  flashcards: Flashcard[]
}

const get = (flashcardId: string) => {
  return client
    .get<GetFlashcardResponse>(`/v1/flashcards/decks/${flashcardId}`)
    .then((resp) => resp.data)
}

export default get
